import create from 'zustand' // create로 zustand를 불러옵니다.

const loadingStore = create(set => ({
    isLoading: false,
    setIsLoading: (boolean) => {
        set({ isLoading: boolean })
    }
}))

export default loadingStore